  import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { BusinessSearchCriteria } from 'backend/interfaces/business.interface';
import { ParentSearchCriteria } from 'backend/interfaces/parent.interface';
import { BusinessService } from 'src/app/admin/services/business.service';
import { ParentService } from 'src/app/admin/services/parent.service';
import { SideNavService } from 'src/app/admin/services/side-nav.service';

@Component({
  selector: 'app-search-business',
  templateUrl: './search-business.component.html',
  styleUrls: ['./search-business.component.scss']
})
export class SearchBusinessComponent implements OnInit {
  loading = false;
  searchParentForm: UntypedFormGroup;
  noResults = false;
  faSearch = faSearch;
  searchPhrase: BusinessSearchCriteria;
  constructor(private fb: UntypedFormBuilder, private businessService: BusinessService, private sideNavService: SideNavService, private router: Router) { }

  ngOnInit(): void {
      this.searchParentForm = this.fb.group(
        {
          name: ['', Validators.required]
      });
      this.businessService.businessSearch$.subscribe(r => {
        this.searchPhrase = r;
        this.searchParentForm.patchValue({...r})
      })
  }

  search(){
    this.noResults = false;
    this.loading = true;
    this.businessService.searchBusiness(this.searchParentForm.value).then(res => {
      if(res.businessess.length > 0){
        this.businessService.businessSearch.next(this.searchParentForm.value);
        this.businessService.businesses.next(res.businessess);
        this.businessService.businessCount.next(res.count);
        this.router.navigate(['admin','businesses']);
        this.sideNavService.close();
      } else {
        this.noResults = true;
      }
      this.loading = false;
    })
  }

  async clearSearch(){
    this.businessService.businessSearch.next({name:  ''});
    this.loading = true;
    await this.businessService.getBusinessCount();
    await this.businessService.getBusinesses(10, 0);
    this.loading = false;
  }
}
